import React from 'react';
import T from 'prop-types';
import cn from 'classnames';

const FormSection = (props) => {
  const { children, title, className } = props;
  return (
    <div className={cn('FormSection', { [className]: className })}>
      <h3 className='title'>{title}</h3>
      {children}
    </div>
  );
};

FormSection.propTypes = {
    children: T.node,
    title: T.string,
    className: T.string,
};

export default FormSection;